var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentPage',[_c('div',{staticClass:"content"},[_c('Adsense',{staticStyle:{"max-height":"150px"},attrs:{"ins-style":"display: block;height: 150px; width: 100%","data-ad-client":"ca-pub-3283982605864712","data-ad-slot":"5250489226","data-ad-format":"horizontal"}}),_c('HistoryTable')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }